<template>
  <label class="app-radio">
    <input
      :data-value="dataValue"
      :checked="value == dataValue"
      :name="name"
      type="radio"
      @change="update"
      v-bind="$attrs" />
    <span></span>
    <div v-if="label" v-html="label"></div>
  </label>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'name',
    'dataValue'
  ],
  methods: {
    update(e) {
      this.$emit('input', e.target.getAttribute('data-value'))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-radio {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.app-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.app-radio span {
  width: 24px;
  height: 24px;
  border: 2px solid #ced4da;
  background-color: white;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}

.app-radio input[type="radio"]:checked + span {
  background-color: rgb(36 137 197);
  border: 2px solid rgb(36 137 197);
}

.app-radio input[type="radio"]:checked + span::after {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
}

.app-radio input[type="radio"]:disabled + span {
  background-color: #e0e0e0;
  border: 2px solid #bdbdbd;
  cursor: not-allowed;
}
</style>